import React, { useState } from "react";
import "./UpcomingEvent.css";
import { Link } from "react-router-dom";

const eventsData = [
  {
    id: "gramayana",
    title: "Residential Summer Camp – Gramayana Edition 2026",
    subtitle: "Warriors of Nature. Keepers of Tradition.",
    ageGroup: "9–15 Years (Boys & Girls)",
    venue: "Shivalingapuram, Kadthal Village (30 Acres Campus)",
    dates: "May 13th – May 20th, 2026",
    fee: "₹9,500 Per Child (All Inclusive)",
    timings: "7-Day Fully Residential Camp",
    image: "./images/LearnMoreResidential.jpg",
    about:
      "Gramayana Residential Summer Camp 2026 is a 7-day immersive rural learning experience blending ancient Indian traditions, martial arts, farming, meditation, village life, cultural arts, and survival cooking. Children disconnect from screens and reconnect with discipline, nature, and values for life.",
    highlights: [
      {
        category: "Ancient Indian Games & Martial Traditions",
        activities:
          "Archery Training, Gada-Mazze Practice, Kalari Basics, Kushti demos, Tyre races, Rope climbing, Bamboo maze"
      },
      {
        category: "Mind & Spirit",
        activities:
          "Daily Pyramid Meditation, Group Journaling, Fire Ritual, Astro Night"
      },
      {
        category: "Animal Husbandry & Farming",
        activities:
          "Milking cows, Feeding calves, Egg collection, Organic farming, Cleaning sheds"
      },
      {
        category: "Traditional Arts",
        activities:
          "Pottery, Kolam (Rangoli), Folk Songs & Dance (Kolattam, Lambadi)"
      },
      {
        category: "Survival Cooking",
        activities:
          "Firewood cooking, Mud stove chapatis, Pongal, Bajra roti, Bamboo rice, Foraging"
      },
      {
        category: "Facilities & Safety",
        activities:
          "Separate dorms, 4 organic meals/day, Doctor on call, Safety staff, 24x7 Camp Manager"
      }
    ],
    brochures: ["./images/g-cam-01.JPEG", "./images/g-cam-02.JPEG"],
    contact: "98498 56143"
  },

  {
    id: "tech-gen-iris",
    title: "Tech Generation Summer Camp 2026 (IRIS Florets)",
    subtitle: "STEM • Life Skills • Adventure • Arts",
    ageGroup: "4–15 Years",
    venue: "IRIS Florets World School, Bongloor, Hyderabad",
    dates: "30 April – 30 May 2026",
    fee: "₹4,499",
    timings: "9:00 AM – 3:00 PM",
    image: "./images/Adventurecamp.jpg",
    about:
      "A dynamic STEM-based day camp combining AI, Coding, Horse Riding, Martial Arts, DJ Mixing, Cinematography, and Creative Arts for holistic child development.",
    programs: [
      {
        name: "Primary School (4–8 Years)",
        focus:
          "Life Skills Games, Pony Riding, Yoga, Puzzle Games, Art & Craft, Storytelling, Nature Play"
      },
      {
        name: "High School (9–15 Years)",
        focus:
          "Leadership Lab, Horse Riding, AI & Coding, Kalaripayattu, DJ Mixing, Movie Direction, Western Dance"
      }
    ],
    highlights: [
      "AI & Coding Introduction",
      "Horse Riding Experience",
      "Indian Martial Arts",
      "DJ Mixing & Music Basics",
      "Fitness & Athletic Training",
      "Confidence Building"
    ],
    brochures: ["./images/IRIS01.jpeg", "./images/IRIS02.jpeg"],
    contact: "98498 56143 | 99495 67143"
  },

  {
    id: "tech-gen-jubilee",
    title: "Tech Generation Summer Camp 2026 (Jubilee Hills)",
    subtitle: "The Future Isn’t Coming. It’s Already Here.",
    ageGroup: "9–15 Years",
    venue: "Ekagra Chess Academy, Jubilee Hills, Hyderabad",
    dates: "April 30 – May 30, 2026",
    fee: "₹9,999",
    timings: "9:00 AM – 1:00 PM",
    image: "./images/AI-MUSIC.jpg",
    about:
      "Premium technology camp focused on Artificial Intelligence, Coding, Machine Learning, Electronic Music Production, and AI Film Making. Designed as a launchpad for young innovators.",
    highlights: [
      "Artificial Intelligence Projects",
      "Structured Coding & Web Design",
      "Machine Learning Basics",
      "Electronic Music Production",
      "AI Film Making & VFX",
      "Small Batch Personalized Training"
    ],
    brochures: ["./images/Ekagra01.jpEg", "./images/Ekagra02.jpEg"],
    contact: "98498 56143 | 99495 67143"
  },

  {
    id: "tech-gen-meridian",
    title: "Tech Generation Summer Camp 2026 (Meridian School, Uppal)",
    subtitle: "STEM • Life Skills • Arts • Adventure",
    ageGroup: "4–15 Years",
    venue: "Meridian School, Uppal, Hyderabad",
    dates: "1st May – 31st May 2026",
    fee: "Contact Venue",
    timings: "Mon–Fri: 9 AM – 3 PM | Sat: Half Day | Sun: Holiday",
    image: "./images/MeridianPIC.jpg",
    about:
      "A high-energy summer camp integrating STEM education, AI, horse riding, martial arts, performing arts, and leadership training in a structured school campus.",
    programs: [
      {
        name: "Primary School (4–8 Years)",
        focus:
          "Life Skills, Pony Riding, Yoga, Storytelling, Creative Art, Traditional Games"
      },
      {
        name: "High School (9–15 Years)",
        focus:
          "Leadership, AI & Coding, Kalaripayattu, DJ Mixing, AI Film Making, Fitness Training"
      }
    ],
    highlights: [
      "STEM Practical Learning",
      "AI & Coding Basics",
      "Horse Riding & Adventure",
      "Indian Martial Arts",
      "Stage Performance",
      "Leadership Development"
    ],
    brochures: ["./images/MeridianUPAL01.jpeg", "./images/MeridianUPAL02.jpeg"],
    contact: "98498 56143 | 99495 67143"
  }
];

const UpcomingEvent = () => {
  const [selectedEvent, setSelectedEvent] = useState(eventsData[0]);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (imgUrl) => {
    setModalImage(imgUrl);
    document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
  };

  const closeModal = () => {
    setModalImage(null);
    document.body.style.overflow = "auto";
  };

  return (
    <div className="upcoming-events-container">
      <div className="header-section">
        <h1 className="main-title">Upcoming Summer Camps 2026</h1>
        <p className="main-subtitle">
          Explore the Best Summer Camps in Hyderabad for Kids & Teens
        </p>
      </div>

      <div className="events-wrapper">
        {/* Sidebar */}
        <div className="event-sidebar">
          {eventsData.map((event) => (
            <div
              key={event.id}
              className={`event-mini-card ${selectedEvent.id === event.id ? "active" : ""
                }`}
              onClick={() => setSelectedEvent(event)}
            >
              <h3>{event.title}</h3>
              <p className="mini-venue">{event.venue}</p>
            </div>
          ))}
        </div>

        {/* Detail View */}
        <div className="event-detail-view">
          <div className="detail-card glassmorphism">
            <div className="badge">{selectedEvent.ageGroup}</div>

            <h2 className="detail-title">{selectedEvent.title}</h2>
            <p className="detail-subtitle">{selectedEvent.subtitle}</p>

            {/* Info Grid */}
            <div className="info-grid">
              <div className="info-item">
                <strong>Dates:</strong>
                <span>{selectedEvent.dates}</span>
              </div>

              <div className="info-item">
                <strong>Venue:</strong>
                <span>{selectedEvent.venue}</span>
              </div>

              <div className="info-item">
                <strong>Fee:</strong>
                <span>{selectedEvent.fee}</span>
              </div>

              {selectedEvent.timings && (
                <div className="info-item">
                  <strong>Timings:</strong>
                  <span>{selectedEvent.timings}</span>
                </div>
              )}
            </div>

            {/* About */}
            <div className="content-section">
              <h3>About the Camp</h3>
              <p>{selectedEvent.about}</p>
            </div>

            {/* Highlights */}
            {selectedEvent.highlights?.length > 0 && (
              <div className="content-section">
                <h3>Highlights</h3>
                <div className="highlights-grid">
                  {selectedEvent.highlights.map((h, i) =>
                    typeof h === "string" ? (
                      <span key={i} className="highlight-tag">
                        {h}
                      </span>
                    ) : (
                      <div key={i} className="highlight-item">
                        <strong>{h.category}:</strong> {h.activities}
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            {/* Programs */}
            {selectedEvent.programs && (
              <div className="content-section">
                <h3>Programs</h3>
                {selectedEvent.programs.map((p, i) => (
                  <div key={i} className="program-item">
                    <h4>{p.name}</h4>
                    <p>{p.focus}</p>
                  </div>
                ))}
              </div>
            )}

            {/* Brochures Section */}
            {selectedEvent.brochures?.length > 0 && (
              <div className="content-section">
                <h3>Camp Brochures</h3>
                <div className="brochures-grid">
                  {selectedEvent.brochures.map((url, i) => (
                    <div
                      key={i}
                      className="brochure-item"
                      onClick={() => openModal(url)}
                    >
                      <img
                        src={url}
                        alt={`Brochure ${i + 1}`}
                        className="brochure-img"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* CTA */}
            <div className="cta-section">
              <div className="contact-info">
                Join Us Now: <strong>{selectedEvent.contact}</strong>
              </div>
              <Link to="/enrollment" className="apply-btn">
                Register Now
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal Popup */}
      {modalImage && (
        <div className="image-modal-overlay" onClick={closeModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={closeModal}>×</button>
            <img src={modalImage} alt="Enlarged Brochure" />
          </div>
        </div>
      )}
    </div>
  );
};

export default UpcomingEvent;